import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import TextSize from "../../utils/textSizeUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import theme from "../../utils/themeUtil";
import { Link } from "react-router-dom";
import Routes from "../../utils/routesUtil";

function Services() {
    return (
        <React.Fragment>
          <Box
              className={styles.container}
              mt={isMobile ? 2 : 5}
              mb={isMobile ? 2 : 8}
          >
              <Grid container spacing={2}>
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                      <Typography
                          className="wow animate__animated animate__fadeInUp animate__slow"
                          style={{ fontSize: TextSize.size24, fontWeight: "bold" }}
                      >
                          {Strings.secureYourFuture}
                      </Typography>
                      <Box
                          mb={5}
                          className="wow animate__animated animate__fadeInUp animate__slow"
                      >
                          <Typography
                              style={{
                                  fontSize: isMobile ? TextSize.size14 : TextSize.size16,
                                  lineHeight: "2",
                                  color: theme.palette.black.main,
                              }}
                          >
                              {Strings.secureYourFutureSubHeader}
                          </Typography>
                      </Box>
                  </Grid>
                  <Grid
                      item
                      xs={12}
                      md={6}
                      style={{ textAlign: isMobile ? "center" : "left" }}
                  >
                      <Box
                          px={3}
                          py={2}
                          style={{
                              background: theme.palette.lightPurple.main,
                              borderRadius: "16px",
                              textAlign: "center",
                          }}
                      >
                          <img
                              src={AppIcons.imgGirlWithPhoneBanner}
                              alt="Girl with phone"
                              style={{ height: "250px" }}
                              className="wow animate__animated animate__zoomIn animate__slow"
                          />
                          <Box height={isMobile ? "auto" : 80}>
                              <Typography
                                  style={{
                                      fontSize: TextSize.size24,
                                      color: theme.palette.white.main,
                                      fontWeight: "500",
                                  }}
                                  className="wow animate__animated animate__fadeInUp animate__delay-0s"
                              >
                                  {Strings.learnEarnShare}
                              </Typography>
                          </Box>
                          <Box mt={2} mb={2} height={isMobile ? "auto" : 40}>
                              <Typography
                                  style={{
                                      fontSize: TextSize.size14,
                                      color: theme.palette.white.main,
                                  }}
                                  className="wow animate__animated animate__fadeInUp animate__delay-0s"
                              >
                                  {Strings.learnEarnShareSubHeader}
                              </Typography>
                          </Box>
                          <Box className="wow animate__animated animate__fadeInUp animate__delay-0s">
                              <Link
                                  to={Routes.MM_PLAY_STORE_URL}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                      fontSize: TextSize.size18,
                                      fontWeight: "500",
                                      color: theme.palette.white.main,
                                  }}
                              >
                                  {Strings.joinTheCommunity}
                              </Link>
                          </Box>
                      </Box>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ textAlign: "center" }}>
                      <Box
                          px={3}
                          py={2}
                          style={{
                              background: theme.palette.yellow.main,
                              borderRadius: "16px",
                              textAlign: "center",
                          }}
                      >
                          <img
                              src={AppIcons.imgFinancialProductServicesBanner}
                              alt="Girl with phone"
                              style={{ height: "250px" }}
                              className="wow animate__animated animate__zoomIn animate__slow"
                          />
                          <Box height={isMobile ? "auto" : 80}>
                              <Typography
                                  style={{
                                      fontSize: TextSize.size24,
                                      color: theme.palette.white.main,
                                      fontWeight: "500",
                                  }}
                                  className="wow animate__animated animate__fadeInUp animate__delay-0s"
                              >
                                  {Strings.financialProductServices}
                              </Typography>
                          </Box>
                          <Box mt={2} mb={2} height={isMobile ? "auto" : 40}>
                              <Typography
                                  style={{
                                      fontSize: TextSize.size14,
                                      color: theme.palette.white.main,
                                  }}
                                  className="wow animate__animated animate__fadeInUp animate__delay-0s"
                              >
                                  {Strings.financialProductServicesSubHeader}
                              </Typography>
                          </Box>
                          <Box className="wow animate__animated animate__fadeInUp animate__delay-0s">
                              <Link
                                  to={Routes.FINANCIAL_PRODUCTS}
                                  style={{
                                      fontSize: TextSize.size18,
                                      fontWeight: "500",
                                      color: theme.palette.white.main,
                                  }}
                              >
                                  {Strings.learnMore}
                              </Link>
                          </Box>
                      </Box>
                  </Grid>
              </Grid>
          </Box>
      </React.Fragment>
  );
}

export default Services;
